import registerRepository from '@/repositories/register/registerRepository'
import registerStep, { getRegisterStep, getUserStep } from '@/constants/register/registerStep'

const getDefaultState = () => {
  return {
    // State
    currStep: registerStep.personalInformation,
    activeTab: registerStep.personalInformation,
    // Data
    nationalities: [],
    phoneCodes: [],
    countries: [],
    provinces: [],
    employmentFinanceQuestions: [],
    tradingQuestions: [],
    isRegisterPath: false,
  }
}

let nationalitiesLang, countriesLang, provincesLang, employmentFinanceQuestionsLang, tradingQuestionsLang

export default {
  namespaced: true,
  state: () => getDefaultState(),
  getters: {},
  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState())
    },
    setState(state, newState) {
      Object.assign(state, newState)
    },
  },
  actions: {
    setIsRegisterPath({ commit }, value) {
      commit('setState', { isRegisterPath: value })
    },
    setStep({ commit }, step) {
      commit('common/setRegisterStep', getUserStep(step), { root: true })
      commit('setState', { currStep: step, activeTab: step })
    },
    setActiveTab({ commit }, tab) {
      commit('setState', { activeTab: tab })
    },
    async getCurrentStep({ dispatch, rootState, rootGetters }) {
      const currentStep = await registerRepository.getCurrentStep()
      if (!(currentStep instanceof Error)) {
        dispatch(
          'setStep',
          getRegisterStep(currentStep, rootState.common.poaAuditStatus, rootGetters['common/poaPass'])
        )
      }
    },
    // Options
    async getNationalities({ commit, state }, lang) {
      if (state.nationalities.length === 0 || nationalitiesLang !== lang) {
        nationalitiesLang = lang
        const nationalities = await registerRepository.getNationalities(lang)
        if (nationalities instanceof Error) {
          commit('setState', {
            nationalities: [],
          })
        } else {
          commit('setState', {
            nationalities,
          })
        }
      }
    },
    async getPhoneCodes({ commit, state }) {
      if (state.phoneCodes.length === 0) {
        const phoneCodes = await registerRepository.getPhoneCodes()
        if (phoneCodes instanceof Error) {
          commit('setState', {
            phoneCodes: [],
          })
        } else {
          commit('setState', {
            phoneCodes,
          })
        }
      }
    },
    async getCountries({ commit, state }, lang) {
      if (state.countries.length === 0 || countriesLang !== lang) {
        countriesLang = lang
        const countries = await registerRepository.getCountries(lang)
        if (countries instanceof Error) {
          commit('setState', {
            countries: [],
          })
        } else {
          commit('setState', {
            countries,
          })
        }
      }
    },
    async getProvinces({ commit, state }, lang) {
      if (state.provinces.length === 0 || provincesLang !== lang) {
        provincesLang = lang
        const provinces = await registerRepository.getProvinces(lang)
        if (provinces instanceof Error) {
          commit('setState', {
            provinces: [],
          })
        } else {
          commit('setState', {
            provinces,
          })
        }
      }
    },
    async getEmploymentFinanceQuestions({ commit, state }, lang) {
      employmentFinanceQuestionsLang = lang
      const employmentFinanceQuestions = await registerRepository.getEmploymentFinanceQuestions(lang)
      if (employmentFinanceQuestions instanceof Error) {
        commit('setState', {
          employmentFinanceQuestions: [],
        })
      } else {
        commit('setState', {
          employmentFinanceQuestions,
        })
      }
    },
    async getTradingQuestions({ commit, state }, lang) {
      tradingQuestionsLang = lang
      const tradingQuestions = await registerRepository.getTradingQuestions(lang)

      if (tradingQuestions instanceof Error) {
        commit('setState', {
          tradingQuestions: [],
        })
      } else {
        commit('setState', {
          tradingQuestions,
        })
      }
    },
  },
}
